import React from 'react';
import { CheckBox, RadioSelector } from "cdhs-ui-library";


export interface AnswerInputListProps {
    answers?: { [key: string]: string; },
    choice?: "M" | "S",
    questionId?: number,
    selectedAnswers: number[],
    onRadioChange?: (event: React.ChangeEvent<HTMLInputElement>) => void,
    onCheckboxChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}
function AnswerInputList(props: AnswerInputListProps) {

  const qIdAsString = props.questionId?.toString()
  return (
    <>
    {props.answers &&
            props.choice === "S" &&
            Object.entries(props.answers).map(([answerKey, answerValue]) => {
              return (
                <div key={answerKey}>
                  <RadioSelector
                    name={qIdAsString ?? ""}
                    variant="NYTD"
                    text={answerValue}
                    value={answerKey}
                    checked={props.selectedAnswers[0] === Number(answerKey)}
                    onChange={props.onRadioChange}
                  />
                </div>
              );
            })}
          {props.answers &&
            props.choice === "M" &&
            Object.entries(props.answers).map(([answerKey, answerValue]) => {
              return (
                <div key={answerKey}>
                  <CheckBox
                    name={qIdAsString ?? ""}
                    variant="NYTD"
                    text={answerValue}
                    value={answerKey}
                    checked={props.selectedAnswers?.includes(Number(answerKey))}
                    onChange={props.onCheckboxChange}
                  />
                </div>
              );
            })}
    </>
  )
}

export default AnswerInputList